import { FC } from 'react';
import { Flex, FlexProps, Text } from '@chakra-ui/react';
import { RewardsActivityCardType, TransactionTypes } from '../../types/RewardsActivityCard';
import { getTransactionColor } from './transactionColor';
import { CbTokenBalance } from '../CbTokenBalance';
export interface CbRewardsActivityCardAmountProps extends FlexProps {
  amount: RewardsActivityCardType['amount'];
  discount?: number;
  transactionType: TransactionTypes;
}
export const CbRewardsActivityCardAmount: FC<CbRewardsActivityCardAmountProps> = ({
  amount = 0,
  discount = 0,
  transactionType,
  ...props
}) => {
  const tokenBalance = transactionType === TransactionTypes.TokensRemoved ? -amount : amount;
  const transactionColor = getTransactionColor(transactionType);
  const color = transactionColor || 'cloud.700';
  return <Flex flexDirection={'column'} data-sentry-element="Flex" data-sentry-component="CbRewardsActivityCardAmount" data-sentry-source-file="CbRewardsActivityCardAmount.tsx">
        <Flex alignItems="center" {...props} data-sentry-element="Flex" data-sentry-source-file="CbRewardsActivityCardAmount.tsx">
          <Text color="text.secondary" fontSize="sm" fontWeight="medium" marginRight={1} data-sentry-element="Text" data-sentry-source-file="CbRewardsActivityCardAmount.tsx">
            {'Amount:'}
          </Text>
          <CbTokenBalance color={color} isPending={false} size="sm" tokenBalance={tokenBalance} withSign data-sentry-element="CbTokenBalance" data-sentry-source-file="CbRewardsActivityCardAmount.tsx" />
        </Flex>
        {discount > 0 && <Flex alignItems="center" {...props}>
            <Text color="venasaur.400" fontSize="xs" fontWeight="medium" marginRight={1}>
              {'You saved:'}
            </Text>
            <CbTokenBalance color={color} isPending={false} size="xs" tokenBalance={discount} />
          </Flex>}
      </Flex>;
};